import PardotForm from "./uiElements/overlays/PardotForm.svelte";
import NoFormDownload from "./uiElements/overlays/NoFormDownload.svelte";

const routes = {
    '/dlpage': NoFormDownload,
    '*': PardotForm
}

export default routes;